/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientResourceGroupFragment = { __typename: 'TenantedResourceGroupType', id: string, createdAt: string, updatedAt: string, isMspModified: boolean, primaryResource?: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null }, primaryApplication?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null } | null } | null> } | null } | null };

export type ClientResourceGroupsQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientResourceGroupsQuery = { __typename: 'Query', tenantedResourceGroups?: { __typename: 'TenantedResourceGroupTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'TenantedResourceGroupTypeEdge', node?: { __typename: 'TenantedResourceGroupType', id: string, createdAt: string, updatedAt: string, isMspModified: boolean, primaryResource?: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null }, primaryApplication?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null } | null } | null> } | null } | null } | null } | null> } | null };

export type ClientResourceGroupQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  resourceGroupId: Types.Scalars['ID']['input'];
}>;


export type ClientResourceGroupQuery = { __typename: 'Query', tenantedResourceGroups?: { __typename: 'TenantedResourceGroupTypeConnection', edges: Array<{ __typename: 'TenantedResourceGroupTypeEdge', node?: { __typename: 'TenantedResourceGroupType', id: string, createdAt: string, updatedAt: string, isMspModified: boolean, primaryResource?: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, allApplications?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, notes?: string | null, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } }, businessOwner?: { __typename: 'ClientEmployeeType', id: string } | null } | null } | null> } | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null }, primaryApplication?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null } | null } | null> } | null } | null } | null } | null> } | null };

export type ClientResourceGroupEmployeesQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  resourceGroupId: Types.Scalars['ID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientResourceGroupEmployeesQuery = { __typename: 'Query', tenantedResourceGroups?: { __typename: 'TenantedResourceGroupTypeConnection', edges: Array<{ __typename: 'TenantedResourceGroupTypeEdge', node?: { __typename: 'TenantedResourceGroupType', id: string, primaryResource?: { __typename: 'ApplicationResourceType', applications?: { __typename: 'ClientApplicationTypeConnection', edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, name: string, email: string, createdAt: string, updatedAt: string } | null } | null> } | null } | null } | null> } | null } | null } | null } | null> } | null };


export const ClientResourceGroupFragmentDoc = `
    fragment ClientResourceGroup on TenantedResourceGroupType {
  id
  createdAt
  updatedAt
  isMspModified
  primaryResource {
    id
    vendorDomainName
    productDomainName
    vendorName
    vendorDescription
    productName
    productDescription
    isForConsumers
    key
    isSaas
    isVisible
    publicResource {
      signedLogoUrl
      category {
        id
        name
        parent {
          id
          name
        }
      }
    }
    primaryApplication: applications(first: 1) {
      edges {
        node {
          id
          reviewState
          managedBy
          supportedBy
          notes
          businessOwner {
            id
            name
          }
        }
      }
      totalCount
    }
  }
}
    `;
export const ClientResourceGroupsDocument = `
    query ClientResourceGroups($clientId: UUID!, $orderBy: String) {
  tenantedResourceGroups(clientId: $clientId, orderBy: $orderBy) {
    edges {
      node {
        ...ClientResourceGroup
      }
    }
    totalCount
  }
}
    ${ClientResourceGroupFragmentDoc}`;

export const useClientResourceGroupsQuery = <
      TData = ClientResourceGroupsQuery,
      TError = unknown
    >(
      variables: ClientResourceGroupsQueryVariables,
      options?: Omit<UseQueryOptions<ClientResourceGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientResourceGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientResourceGroupsQuery, TError, TData>(
      {
    queryKey: ['ClientResourceGroups', variables],
    queryFn: fetcher<ClientResourceGroupsQuery, ClientResourceGroupsQueryVariables>(ClientResourceGroupsDocument, variables),
    ...options
  }
    )};

useClientResourceGroupsQuery.getKey = (variables: ClientResourceGroupsQueryVariables) => ['ClientResourceGroups', variables];

export const useInfiniteClientResourceGroupsQuery = <
      TData = InfiniteData<ClientResourceGroupsQuery>,
      TError = unknown
    >(
      variables: ClientResourceGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientResourceGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientResourceGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientResourceGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientResourceGroups.infinite', variables],
      queryFn: (metaData) => fetcher<ClientResourceGroupsQuery, ClientResourceGroupsQueryVariables>(ClientResourceGroupsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientResourceGroupsQuery.getKey = (variables: ClientResourceGroupsQueryVariables) => ['ClientResourceGroups.infinite', variables];


useClientResourceGroupsQuery.fetcher = (variables: ClientResourceGroupsQueryVariables) => fetcher<ClientResourceGroupsQuery, ClientResourceGroupsQueryVariables>(ClientResourceGroupsDocument, variables);

export const ClientResourceGroupDocument = `
    query ClientResourceGroup($clientId: UUID!, $resourceGroupId: ID!) {
  tenantedResourceGroups(clientId: $clientId, id: $resourceGroupId) {
    edges {
      node {
        ...ClientResourceGroup
        primaryResource {
          id
          allApplications: applications {
            edges {
              node {
                id
                createdAt
                updatedAt
                notes
                reviewState
                managedBy
                supportedBy
                resource {
                  id
                  vendorDomainName
                  productDomainName
                  vendorName
                  vendorDescription
                  productName
                  productDescription
                  isForConsumers
                  key
                  isSaas
                  isVisible
                  publicResource {
                    signedLogoUrl
                    category {
                      id
                      name
                    }
                  }
                }
                businessOwner {
                  id
                }
              }
            }
            totalCount
          }
        }
      }
    }
  }
}
    ${ClientResourceGroupFragmentDoc}`;

export const useClientResourceGroupQuery = <
      TData = ClientResourceGroupQuery,
      TError = unknown
    >(
      variables: ClientResourceGroupQueryVariables,
      options?: Omit<UseQueryOptions<ClientResourceGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientResourceGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientResourceGroupQuery, TError, TData>(
      {
    queryKey: ['ClientResourceGroup', variables],
    queryFn: fetcher<ClientResourceGroupQuery, ClientResourceGroupQueryVariables>(ClientResourceGroupDocument, variables),
    ...options
  }
    )};

useClientResourceGroupQuery.getKey = (variables: ClientResourceGroupQueryVariables) => ['ClientResourceGroup', variables];

export const useInfiniteClientResourceGroupQuery = <
      TData = InfiniteData<ClientResourceGroupQuery>,
      TError = unknown
    >(
      variables: ClientResourceGroupQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientResourceGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientResourceGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientResourceGroupQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientResourceGroup.infinite', variables],
      queryFn: (metaData) => fetcher<ClientResourceGroupQuery, ClientResourceGroupQueryVariables>(ClientResourceGroupDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientResourceGroupQuery.getKey = (variables: ClientResourceGroupQueryVariables) => ['ClientResourceGroup.infinite', variables];


useClientResourceGroupQuery.fetcher = (variables: ClientResourceGroupQueryVariables) => fetcher<ClientResourceGroupQuery, ClientResourceGroupQueryVariables>(ClientResourceGroupDocument, variables);

export const ClientResourceGroupEmployeesDocument = `
    query ClientResourceGroupEmployees($clientId: UUID!, $resourceGroupId: ID!, $first: Int, $offset: Int, $orderBy: String) {
  tenantedResourceGroups(clientId: $clientId, id: $resourceGroupId) {
    edges {
      node {
        id
        primaryResource {
          applications {
            edges {
              node {
                id
                employees(first: $first, offset: $offset, orderBy: $orderBy) {
                  edges {
                    node {
                      id
                      name
                      email
                      createdAt
                      updatedAt
                    }
                  }
                  totalCount
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useClientResourceGroupEmployeesQuery = <
      TData = ClientResourceGroupEmployeesQuery,
      TError = unknown
    >(
      variables: ClientResourceGroupEmployeesQueryVariables,
      options?: Omit<UseQueryOptions<ClientResourceGroupEmployeesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientResourceGroupEmployeesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientResourceGroupEmployeesQuery, TError, TData>(
      {
    queryKey: ['ClientResourceGroupEmployees', variables],
    queryFn: fetcher<ClientResourceGroupEmployeesQuery, ClientResourceGroupEmployeesQueryVariables>(ClientResourceGroupEmployeesDocument, variables),
    ...options
  }
    )};

useClientResourceGroupEmployeesQuery.getKey = (variables: ClientResourceGroupEmployeesQueryVariables) => ['ClientResourceGroupEmployees', variables];

export const useInfiniteClientResourceGroupEmployeesQuery = <
      TData = InfiniteData<ClientResourceGroupEmployeesQuery>,
      TError = unknown
    >(
      variables: ClientResourceGroupEmployeesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientResourceGroupEmployeesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientResourceGroupEmployeesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientResourceGroupEmployeesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientResourceGroupEmployees.infinite', variables],
      queryFn: (metaData) => fetcher<ClientResourceGroupEmployeesQuery, ClientResourceGroupEmployeesQueryVariables>(ClientResourceGroupEmployeesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientResourceGroupEmployeesQuery.getKey = (variables: ClientResourceGroupEmployeesQueryVariables) => ['ClientResourceGroupEmployees.infinite', variables];


useClientResourceGroupEmployeesQuery.fetcher = (variables: ClientResourceGroupEmployeesQueryVariables) => fetcher<ClientResourceGroupEmployeesQuery, ClientResourceGroupEmployeesQueryVariables>(ClientResourceGroupEmployeesDocument, variables);
